import { useCallback, useRef, useState } from 'react';
import { ISankeyGraph } from './interfaces';

/**
 * Sankey State produced by D3Sankey is cyclic (nodes reference links and vice versa)
 * and cannot be expressed with React-friendly state structures. This hooks
 * encapsulates mutation logic and forces rendering of the component
 */
export const useSankeyState = () => {
  const sankeyRef = useRef<ISankeyGraph>({ nodes: [], links: [] });
  const [, setForceRerender] = useState(0);
  const [forceRecreateSankeyUpdate, setForceRecreateSankeyUpdate] = useState(0);

  const sankeyUpdate = useCallback(
    (updateFunc: (sankey: ISankeyGraph) => unknown) => {
      updateFunc(sankeyRef.current);
      setForceRerender((c) => c + 1);
    },
    // Svilen:
    // If there are effects that depend on the state (sankeyRef), they will
    // be executed when the entire sankey chart is replaced, by updating this
    // callback. This is very hacky solution to
    // https://kubitai.atlassian.net/browse/KB-7051?focusedCommentId=28895
    // We should refactor Sankey state not to contain references between
    // links and nodes
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [forceRecreateSankeyUpdate],
  );

  const sankeyReplace = useCallback((sankeyState: ISankeyGraph) => {
    sankeyRef.current = sankeyState;
    setForceRecreateSankeyUpdate((c) => c + 1);
  }, []);

  return {
    sankeyReplace,
    sankeyUpdate,
    sankey: sankeyRef.current,
  };
};
